import { TabPanel as MuiTabPanel, type TabPanelProps } from '@mui/base'
import { clsx } from 'clsx'
import { type JSX } from 'react'

export const TabPanel = (props: TabPanelProps): JSX.Element => {
  const { className } = props

  return <MuiTabPanel {...props} className={clsx('tab-panel', className)} />
}
